/**
 * 雷音寺菜单的唯一课程映射。
 *
 * 图片内已经包含模块名称，因此 serialId、name、grade 与 imageName 必须一起移动。
 * 设计说明见 docs/leiyinsi-grade-module-mapping.md。
 */
export const YINGSHI_PAGE_ENTRIES = [
  [
    { serialId: 985, name: '读经小士', grade: '独立内容', imageName: 'menu4-1.webp' },
    { serialId: 986, name: '学法小徒', grade: '三年级', imageName: 'menu4-2.webp' },
    { serialId: 987, name: '巧答小仙', grade: '四年级', imageName: 'menu4-3.webp' },
    { serialId: 988, name: '智慧小圣', grade: '五年级', imageName: 'menu4-4.webp' },
  ],
  [
    { serialId: 989, name: '智慧中圣', grade: '六年级', imageName: 'menu5-1.webp' },
    { serialId: 990, name: '学法中徒', grade: '七年级（初一）', imageName: 'menu5-2.webp' },
    { serialId: 991, name: '读经中士', grade: '八年级（初二）', imageName: 'menu5-3.webp' },
    { serialId: 992, name: '学法高徒', grade: '九年级（初三）', imageName: 'menu6-1.webp' },
  ],
  [
    { serialId: 993, name: '读经高士', grade: '高一', imageName: 'menu6-2.webp' },
    { serialId: 994, name: '智慧大圣', grade: '高二', imageName: 'menu6-3.webp' },
    { serialId: 995, name: '博学天尊', grade: '高三', imageName: 'menu5-4.webp' },
  ],
];

export const YINGSHI_GRADE_START_SERIAL = 986;
export const YINGSHI_RESERVED_SERIAL = 996;
export const YINGSHI_VISIBLE_SERIALS = YINGSHI_PAGE_ENTRIES.flat().map(({ serialId }) => serialId);
export const YINGSHI_SERIALS = [...YINGSHI_VISIBLE_SERIALS, YINGSHI_RESERVED_SERIAL];
export const YINGSHI_SLIDE_LENS = YINGSHI_PAGE_ENTRIES.map((page) => page.length);
export const YINGSHI_IMAGE_NAMES = YINGSHI_PAGE_ENTRIES.map((page) => (
  page.map(({ imageName }) => imageName)
));
